"use client";

import {
  CheckCircle,
  Sparkles,
  BarChart3,
  Zap,
  Fingerprint,
  Star,
  Calendar,
  Target,
  RefreshCw,
} from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import Safari from "./safari";
import { Badge } from "@/components/ui/badge";

const steps = [
  {
    title: "Find Inspiration For Your Content",
    tag: "INSPIRATION",
    image: "/dummy-image.svg",
    features: [
      {
        text: "Discover trending ideas instantly",
        icon: CheckCircle,
      },
      {
        text: "Access millions of viral examples",
        icon: Sparkles,
      },
      {
        text: "Analyze audience engagement patterns",
        icon: BarChart3,
      },
    ],
  },
  {
    title: "Transform Ideas With Creative Twists",
    tag: "CREATE",
    image: "/dummy-image.svg",
    features: [
      {
        text: "Apply AI-powered enhancements",
        icon: Zap,
      },
      {
        text: "Personalize to match your voice",
        icon: Fingerprint,
      },
      {
        text: "Turn generic into outstanding",
        icon: Star,
      },
    ],
  },
  {
    title: "Schedule Content For Maximum Impact",
    tag: "PUBLISH",
    image: "/dummy-image.svg",
    features: [
      {
        text: "Automate your content calendar",
        icon: Calendar,
      },
      {
        text: "Optimize posting for engagement",
        icon: Target,
      },
      {
        text: "Maintain consistency effortlessly",
        icon: RefreshCw,
      },
    ],
  },
];

export default function GridList10() {
  return (
    <section className="pb-20 pt-20 md:pb-32 md:pt-32">
      <div className="mx-auto flex max-w-6xl flex-col justify-center gap-y-12">
        {/* Title Section */}
        <div className="text-center space-y-4 pb-16 mx-auto max-w-4xl">
          <Badge>FEATURES</Badge>
          <h2 className="mx-auto mt-4 text-3xl font-bold sm:text-5xl tracking-tight">
            Powerful Features
          </h2>
          <p className="text-xl text-muted-foreground pt-1">
            Ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod
            tempor incididunt ut labore.
          </p>
        </div>

        <div>
          {steps.map((step, index) => (
            <Card
              key={index}
              className={`${
                index == 0 ? "" : "mt-16"
              }  bg-primary/5 dark:bg-card shadow-none border-none`}
            >
              <CardContent className="p-0">
                <div
                  className={`flex flex-col ${
                    index % 2 === 0 ? "lg:flex-row" : "lg:flex-row-reverse"
                  } items-center`}
                >
                  <div className="w-full lg:w-1/2 p-6 lg:p-14">
                    <p className="text-md font-semibold tracking-wider mb-4 text-muted-foreground">
                      {step.tag}
                    </p>
                    <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-6">
                      {step.title}
                    </h2>
                    <ul className="space-y-4 mb-8">
                      {step.features.map((item, featureIndex) => (
                        <li key={featureIndex} className="flex items-start">
                          <span className="mr-3 p-2 bg-primary/20 rounded-lg">
                            <item.icon className="h-5 w-5 text-primary" />
                          </span>
                          <span className="text-muted-foreground w-full dark:text-white bg-white dark:bg-accent p-2 rounded-lg">
                            {item.text}
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="md:w-1/2 p-6">
                    <div className="flex justify-center items-center">
                      <Safari
                        src={step.image}
                        className="w-full h-auto rounded-lg aspect-video"
                      />
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
